
import { computed, defineComponent, getCurrentInstance } from "vue";

import { CBtn, CIcon } from "../../vuetify-components";

export default defineComponent({
  components: { CBtn, CIcon },
  mixins: [CBtn],
  props: {
    isFollowing: {
      type: [Boolean, String],
      default: false,
    },
    isLarge: {
      type: [Boolean, String],
      default: false,
    },
  },
  setup(props, _context) {
    const vm = getCurrentInstance()?.proxy;

    const label = computed(() => {
      return props.isFollowing ? vm?.$gettext("following") : vm?.$gettext("follow");
    });

    const iconName = computed(() => {
      if (props.isFollowing) {
        if (props.isLarge) {
          return "$complete";
        }
        return "capsule-consumer-check-outline-8";
      }
      if (props.isLarge) {
        return "$add";
      }
      return "capsule-consumer-plus-outline-8";
    });

    return {
      label,
      iconName,
    };
  },
});
